<template>
  <div>
    <div class="text-h6 mt-2 mb-3 d-block d-md-none">
      <v-icon color="grey" style="margin-bottom: 3px;">mdi-tune</v-icon>
      {{ $t('title') }}
    </div>

    <a-subscription-widget></a-subscription-widget>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionsPage',
}
</script>

<i18n>
{
	"en": {
		"title": "Subscriptions"
	},
	"es": {
		"title": "Suscripcións"
	},
	"fr": {
		"title": "Souscriptions"
	},
	"it": {
		"title": "Abbonamenti"
	},
	"pt": {
		"title": "Subscrições"
	},
	"pl": {
		"title": "Subskrypcje"
	}
}
</i18n>